import React from "react";
import DOMPurify from "dompurify";
import { useInView } from "react-intersection-observer";

import { formatBytes } from "../../../../../helpers/Utils";
import SectionTitleWidget from "../../../../../components/SectionTitleWidget/SectionTitleWidget";
import ProductCategory from "./ProductCategory";
import WeaveDetails from "./WeaveDetails";

import Authors from "./Authors";
import ProductPrice from "../price/ProductPrice";
import InfoBubble from "../../../../../components/InfoBubble/InfoBubble";

import s from "./ListingOverview.module.scss";
import CopyTextWidget from "../../../../../components/CopyTextWidget/CopyTextWidget";

export default function ListingOverview({
	product = {},
	//updateSection = () => {},
	viewCategoryProducts = () => {},
}) {
	const { ref } = useInView({ threshold: 0.5 });
	const { weave } = product;

	/* useEffect(() => {
		if (inView) updateSection("overview");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inView]); */

	return (
		<div className={s.root} id="overview" ref={ref}>
			<div className={s.section}>
				<SectionTitleWidget title="Overview" className={s.sectionTitle} />

				<ProductCategory
					category={product.category}
					onClick={viewCategoryProducts}
				/>

				<p className={s.title}>{product.title}</p>

				{/* AUTHORS */}
				<Authors product={product} />

				{/* BRIEF DESC */}
				{product.description && (
					<>
						<div className={s.sectionSubtitle}>Description:</div>
						<p className={s.text}>{product.description}</p>
					</>
				)}

				{/* FULL DESC */}
				{product.full_description && (
					<>
						<div className={s.sectionSubtitle}>Full Description:</div>
						<p
							className={s.text}
							dangerouslySetInnerHTML={{
								__html: DOMPurify.sanitize(product.full_description),
							}}
						/>
					</>
				)}

				{/* DOWNLOAD SIZE */}
				{product.size && (
					<>
						<div className={s.sectionSubtitle}>Estimated Download Size:</div>
						<p className={s.text}>{formatBytes(product.size)}</p>
					</>
				)}

				{/* PRICE */}
				{product.price && (
					<>
						<div className={s.sectionSubtitle}>
							<span>Estimated Total Price</span>
							<InfoBubble />
						</div>
						<ProductPrice product={product} className={s.text} />
					</>
				)}

				{/* DATABASE DID */}
				{product.database_did && (
					<CopyTextWidget
						title="Dataset DID:"
						text={product.database_did}
						className={s.text}
						titleStyle={s.sectionSubtitle}
					/>
				)}

				{/* WEAVE */}
				{weave && <WeaveDetails weave={weave} product={product} />}
			</div>
		</div>
	);
}
